import React from "react";
import SubmittedCopyright from "../../sumitted_copyright/SubmittedCopyright";

const UnauthorizedCopyright = () => {
  const fileStatus = 6;
  const applicationPath = {
    copyright: "/admin/unauthorized-copyright",
    agreement: "/admin/unauthorized-agreement",
  };
  const detailsRoute = "/admin/unauthorized-copyright-details";
  const pageTitle  = "চূড়ান্তভাবে অননুমোদন";
  return (
    <SubmittedCopyright
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      detailsRoute={detailsRoute}
      pageTitle={pageTitle}
    />
  );
};

export default UnauthorizedCopyright;
